


































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { bus } from "../../main";
import { EnterpriseInfo } from "../../_models/enterpriseInfo";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";

@Component
export default class EditEnterpriseInfoStepper extends Vue {
  @Prop() info!: EnterpriseInfo;
  private e1: number;
  private id: number;
  private estero: string;
  private rapprEstero: string;

  private titolo: string;
  private denominazioneAzienda: string;
  private cognomeRappresentanteAzienda: string;
  private nomeRappresentanteAzienda: string;
  private comuneAzienda: string;
  private idCapComuneAzienda: number;
  private provinciaAzienda: string;
  private indirizzoAzienda: string;
  private telefono1Azienda: string;
  private telefono2Azienda: string;
  private faxAzienda: string;
  private emailAzienda: string;
  private pecAzienda: string;
  private sitoAzienda: string;
  private attivitàAzienda: string;
  private dipendentiAzienda: string;
  private committenzaAzienda: string;
  // private associata: string;
  private associata: boolean;
  // private artigiana: string;
  private artigiana: boolean;
  private pIva: string;
  private codAzienda: string;
  private dataNascitaRappresentante: string;
  private statoNascitaRappresentante: string;
  private luogoNascitaRappresentante: string;
  private idAteco: string;
  // private idIstat: string;
  private statoAzienda: string;
  // private codAteco: string;
  // private codIstat: string;
  private descrizioneAteco: string;
  private descrizioneIstat: string;
  private cap: string;
  private numDipendenti: string[];
  private nazioneAzienda: string;
  private codRappresentate: string;
  private confCommercio: boolean;
  private altraAssociazione:boolean;

  private titoli: string[];

  private denominazioneRules: [boolean | string];
  private cognomeRappresentanteRules: [boolean | string];
  private nomeRappresentanteRules: [boolean | string];
  private luogoRules: [boolean | string];
  private tel1Rules: [boolean | string];
  private tel2Rules: [boolean | string];
  private faxRules: [boolean | string];
  private emailRules: [boolean | string];
  private pecRules: [boolean | string];
  private pIvaRules: [boolean | string];
  private dataRules: [boolean | string];
  private committenzaRules: [boolean | string];
  private attivitàRules: [boolean | string];
  // private pivaRules: [boolean | string];
  private codRules: [boolean | string];
  private numRules: [boolean | string];
  // private idAtecoRules: [boolean | string];
  // private descrAtecoRules: [boolean | string];
  // private idIstatRules: [boolean | string];
  // private descrIstatRules: [boolean | string];
  private capRules: [boolean | string];
  private indirizzoRules: [boolean | string];
  private sitoRules: [boolean | string];
  private codRappresentateRules: [boolean | string]; 

  private stati: any;
  private searchStati: object | null;
  private isLoadingStati: boolean;
  private searchStatiRappr: object | null;
  private isLoadingStatiRappr: boolean;
  private comuni: any;
  private searchComuni: object | null;
  private isLoadingComuni: boolean;
  private searchComuniRappr: object | null;
  private isLoadingComuniRappr: boolean;
  private atecoList: any;
  private searchAteco: object | null;
  private isLoadingAteco: boolean;
  private istatList: any;
  private searchIstat: object | null;
  private isLoadingIstat: boolean;

  constructor() {
    super();
    this.e1 = 1;
    this.id = this.info.idAzienda;
    this.estero = "false";
    this.rapprEstero = "false";

    this.titolo = this.info.titolo;
    this.denominazioneAzienda = this.info.denominazioneAzienda;
    this.cognomeRappresentanteAzienda = this.info.cognomeRappresentanteAzienda;
    this.nomeRappresentanteAzienda = this.info.nomeRappresentanteAzienda;
    this.comuneAzienda = this.info.comuneAzienda;
    this.idCapComuneAzienda = this.info.idCapComuneAzienda;
    this.provinciaAzienda = this.info.provinciaAzienda;
    this.indirizzoAzienda = this.info.indirizzoAzienda;
    this.telefono1Azienda = this.info.telefono1Azienda;
    this.telefono2Azienda = this.info.telefono2Azienda;
    this.faxAzienda = this.info.faxAzienda;
    this.emailAzienda = this.info.emailAzienda;
    this.pecAzienda = this.info.pecAzienda;
    this.sitoAzienda = this.info.sitoAzienda;
    this.attivitàAzienda = this.info.attivitàAzienda;
    this.dipendentiAzienda = this.info.dipendentiAzienda;
    this.committenzaAzienda = this.info.committenzaAzienda;
    this.associata = this.info.associata;
    this.artigiana = this.info.artigiana;
    this.pIva = this.info.pIva;
    this.codAzienda = this.info.codAzienda;
    this.dataNascitaRappresentante = this.info.dataNascitaRappresentante;
    this.statoNascitaRappresentante = this.info.statoNascitaRappresentante;
    this.luogoNascitaRappresentante = this.info.luogoNascitaRappresentante;
    this.idAteco = this.info.idAteco;
    // this.idIstat = this.info.idIstat;
    this.statoAzienda = this.info.idNazioneAzienda;
    // this.codAteco = this.info.codAteco;
    // this.codIstat = this.info.codIstat;
    this.descrizioneAteco = this.info.descrizioneAteco;
    this.descrizioneIstat = this.info.descrizioneIstat;
    this.cap = this.info.cap;
    this.nazioneAzienda = this.info.nazioneAzienda;
    this.codRappresentate = this.info.codRappresentate
    this.confCommercio = this.info.confCommercio;
    this.altraAssociazione = this.info.altraAssociazione;

    this.numDipendenti = [
      "DA 1 A 9",
      "DA 10 A 49",
      "DA 50 A 249",
      "DA 250 A 499",
      "500 E OLTRE"
    ];
    this.titoli = ["Sig.", "Sig.ra"];

    this.denominazioneRules = [true];
    this.cognomeRappresentanteRules = [true];
    this.nomeRappresentanteRules = [true];
    this.luogoRules = [true];
    this.tel1Rules = [true];
    this.tel2Rules = [true];
    this.faxRules = [true];
    this.emailRules = [true];
    this.pecRules = [true];
    this.pIvaRules = [true];
    this.dataRules = [true];
    this.committenzaRules = [true];
    this.attivitàRules = [true];
    // this.pivaRules = [true];
    this.codRules = [true];
    this.numRules = [true];
    // this.idAtecoRules = [true];
    // this.descrAtecoRules = [true];
    // this.idIstatRules = [true];
    // this.descrIstatRules = [true];
    this.capRules = [true];
    this.indirizzoRules = [true];
    this.sitoRules = [true];
    this.codRappresentateRules = [true]

    this.stati = [];
    this.searchStati = null;
    this.isLoadingStati = false;
    this.searchStatiRappr = null;
    this.isLoadingStatiRappr = false;
    this.comuni = [];
    this.searchComuni = null;
    this.isLoadingComuni = false;
    this.searchComuniRappr = null;
    this.isLoadingComuniRappr = false;
    this.atecoList = [];
    this.searchAteco = null;
    this.isLoadingAteco = false;
    this.istatList = [];
    this.searchIstat = null;
    this.isLoadingIstat = false;
  }

  get isDittaIdividuale() {
    var valid = false;
    valid = /^[a-zA-Z]{6}[a-zA-Z0-9]{2}[a-zA-Z][a-zA-Z0-9]{2}[a-zA-Z][a-zA-Z0-9]{3}[a-zA-Z]$/.test(
      this.pIva
    );
    return valid;
  }

  @Watch("luogoNascitaRappresentante")
  onLNascitaRapprChange(value: string) {
    this.luogoNascitaRappresentante = value.toUpperCase();
  }

  @Watch("codAzienda")
  onCodChange(value: string) {
    this.codAzienda = value.toUpperCase();
  }

  @Watch("nomeRappresentanteAzienda")
  onNomeRapprChange(value: string) {
    this.nomeRappresentanteAzienda = value.toUpperCase();
  }

  @Watch("cognomeRappresentanteAzienda")
  onCognomeRapprChange(value: string) {
    this.cognomeRappresentanteAzienda = value.toUpperCase();
  }

  @Watch("searchStati")
  onStatiChanged(value: string) {
    if (this.stati.length > 0) return;
    this.isLoadingStati = true;
    data
      .dispatchStatiList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.stati = response;
        }
      })
      .catch(error => {
        bus.$emit("errorOperation", "Errore nel caricamento della lista stati");
      })
      .finally(() => (this.isLoadingStati = false));
  }

  @Watch("searchComuni")
  onPropertyChanged(value: string) {
    if (this.comuni.length > 0) return;
    this.isLoadingComuni = true;
    data
      .dispatchComuniList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.comuni = response;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      })
      .finally(() => (this.isLoadingComuni = false));
  }

  @Watch("searchAteco")
  onAtecoChange(value: string) {
    if (this.atecoList.length > 0) return;
    this.isLoadingAteco = true;
    data
      .dispatchAtecoList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.atecoList = response;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista codici ATECO"
        );
      })
      .finally(() => (this.isLoadingAteco = false));
  }

  @Watch("searchIstat")
  onIstatChange(value: string) {
    if (this.istatList.length > 0) return;
    this.isLoadingIstat = true;
    data
      .dispatchIstatList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.istatList = response;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista codici CP ISTAT"
        );
      })
      .finally(() => (this.isLoadingIstat = false));
  }

  validazioneCommittenza() {
    var valid: boolean = false;
    if (this.committenzaAzienda === "" || this.committenzaAzienda === null) {
      this.committenzaRules = [true];
    } else {
      if (this.committenzaAzienda !== "" || this.committenzaAzienda !== null) {
        valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.committenzaAzienda);
      }
      if (valid) {
        this.committenzaRules = [true];
      } else {
        this.committenzaRules = [
          "Committenza non può avere più di 50 caratteri e non deve contenere caratteri speciali o numeri"
        ];
      }
    }
  }
  validazioneAttività() {
    var valid: boolean = false;
    if (this.attivitàAzienda === "" || this.attivitàAzienda === null) {
      this.attivitàRules = [true];
    } else {
      if (this.attivitàAzienda !== "" || this.attivitàAzienda !== null) {
        valid = /^[a-zA-Zìèéùòà,.;'\x20-]{2,250}$/.test(this.attivitàAzienda);
      }
      if (valid) {
        this.attivitàRules = [true];
      } else {
        this.attivitàRules = [
          "Attività azienda non può avere più di 250 caratteri e non deve contenere caratteri speciali o numeri"
        ];
      }
    }
  }
  // validazionePiva() {}
  validazioneCod() {
    var valid: boolean = false;
    if (this.codAzienda === "" || this.codAzienda === null) {
      this.codRules = [true];
    } else {
      if (this.codAzienda !== "" || this.codAzienda !== null) {
        valid = /^[A-Z]{6}[A-Z0-9]{2}[A-Z][A-Z0-9]{2}[A-Z][A-Z0-9]{3}[A-Z]$/.test(
          this.codAzienda
        );
      }
      if (valid) {
        this.codRules = [true];
      } else {
        this.codRules = [
          "Codice fiscale deve essere scritto con caratteri maiuscoli"
        ];
      }
    }
  }
  validazioneNum() {
    var valid: boolean = false;
    if (this.dipendentiAzienda === "" || this.dipendentiAzienda === null) {
      this.numRules = [true];
    } else {
      if (this.dipendentiAzienda !== "" || this.dipendentiAzienda !== null) {
        valid = /^[a-zA-Z0-9\x20]{2,15}$/.test(this.dipendentiAzienda);
      }
      if (valid) {
        this.numRules = [true];
      } else {
        this.numRules = ["N° Dipendenti non può contenere caratteri speciali"];
      }
    }
  }
  // validazioneDescrAteco() {
  //   var valid: boolean = false;
  //   if (this.descrizioneAteco === "" || this.descrizioneAteco === null) {
  //     this.descrAtecoRules = [true];
  //   } else {
  //     if (this.descrizioneAteco !== "" || this.descrizioneAteco !== null) {
  //       valid = /^[a-zA-Zìèéùòà'\x20]{2,200}$/.test(this.descrizioneAteco);
  //     }
  //     if (valid) {
  //       this.descrAtecoRules = [true];
  //     } else {
  //       this.descrAtecoRules = [
  //         "Descrizione ATECO non può avere più di 200 caratteri e non deve contenere caratteri speciali o numeri"
  //       ];
  //     }
  //   }
  // }
  // validazioneDescrIstat() {
  //   var valid: boolean = false;
  //   if (this.descrizioneIstat === "" || this.descrizioneIstat === null) {
  //     this.descrIstatRules = [true];
  //   } else {
  //     if (this.descrizioneIstat !== "" || this.descrizioneIstat !== null) {
  //       valid = /^[a-zA-Zìèéùòà'\x20]{2,200}$/.test(this.descrizioneIstat);
  //     }
  //     if (valid) {
  //       this.descrIstatRules = [true];
  //     } else {
  //       this.descrIstatRules = [
  //         "Descrizione ISTAT non può avere più di 200 caratteri e non deve contenere caratteri speciali o numeri"
  //       ];
  //     }
  //   }
  // }
  validazioneCap() {
    var valid: boolean = false;
    if (this.cap === "" || this.cap === null) {
      this.capRules = [true];
    } else {
      if (this.cap !== "" || this.cap !== null) {
        valid = /^[0-9]{5}$/.test(this.cap);
      }
      if (valid) {
        this.capRules = [true];
      } else {
        this.capRules = ["Formato Cap errato"];
      }
    }
  }
  validazioneZip() {
    var valid: boolean = false;
    if (this.cap === "" || this.cap === null) {
      this.capRules = [true];
    } else {
      if (this.cap !== "" || this.cap !== null) {
        valid = /^[0-9]{5,11}$/.test(this.cap);
      }
      if (valid) {
        this.capRules = [true];
      } else {
        this.capRules = ["Formato Codice Zip errato"];
      }
    }
  }
  validazioneIndirizzo() {
    var valid: boolean = false;
    if (this.indirizzoAzienda === "" || this.indirizzoAzienda === null) {
      this.indirizzoRules = [true];
    } else {
      if (this.indirizzoAzienda !== "" || this.indirizzoAzienda !== null) {
        valid = /^[a-zA-Z00-9ìèéùòà,.'\x20/-]{2,100}$/.test(
          this.indirizzoAzienda
        );
      }
      if (valid) {
        this.indirizzoRules = [true];
      } else {
        this.indirizzoRules = [
          "Indirizzo non può avere più di 100 caratteri e non deve contenere caratteri speciali"
        ];
      }
    }
  }
  validazioneSito() {
    var valid: boolean = false;
    if (this.sitoAzienda === "" || this.sitoAzienda === null) {
      this.sitoRules = [true];
    } else {
      if (this.sitoAzienda !== "" || this.sitoAzienda !== null) {
        valid = /^[a-zA-Z0-9ìèéùòà'&.\x20/-]{2,50}$/.test(this.sitoAzienda);
      }
      if (valid) {
        this.sitoRules = [true];
      } else {
        this.sitoRules = ["Sito Azienda non può avere più di 50 caratteri"];
      }
    }
  }

  validazioneDenominazione() {
    var valid: boolean = false;
    if (
      this.denominazioneAzienda !== "" ||
      this.denominazioneAzienda !== null
    ) {
      valid = /^[a-zA-Z0-9ìèéùòà'&.,\x20-]{2,50}$/.test(
        this.denominazioneAzienda
      );
    }
    if (valid) {
      this.denominazioneRules = [true];
    } else if (
      this.denominazioneAzienda === "" ||
      this.denominazioneAzienda === null
    ) {
      this.denominazioneRules = ["Denominazione Azienda necessaria"];
    } else {
      this.denominazioneRules = [
        "Denominazione Azienda deve essere compresa tra i 2 e i 50 caratteri"
      ];
    }
  }
  validazioneCognomeRappresentante() {
    var valid: boolean = false;
    if (
      this.cognomeRappresentanteAzienda === "" ||
      this.cognomeRappresentanteAzienda === null
    ) {
      this.cognomeRappresentanteRules = [true];
    } else {
      if (
        this.cognomeRappresentanteAzienda !== "" ||
        this.cognomeRappresentanteAzienda !== null
      ) {
        valid = /^[a-zA-Zìèéùòà'\x20]{2,100}$/.test(
          this.cognomeRappresentanteAzienda
        );
      }
      if (valid) {
        this.cognomeRappresentanteRules = [true];
      } else {
        this.cognomeRappresentanteRules = [
          "Cognome Rappesentante Azienda deve essere compreso tra i 2 e i 100 caratteri"
        ];
      }
    }

    // var valid: boolean = false;
    // if (this.cognomeRappresentanteAzienda !== "") {
    //   valid = /^[a-zA-Zìèéùòà'\x20]{2,100}$/.test(
    //     this.cognomeRappresentanteAzienda
    //   );
    // }
    // if (valid) {
    //   this.cognomeRappresentanteRules = [true];
    // } else if (this.cognomeRappresentanteAzienda === "") {
    //   this.cognomeRappresentanteRules = [
    //     "Cognome Rappresentante Azienda necessario"
    //   ];
    // } else {
    //   this.cognomeRappresentanteRules = [
    //     "Cognome Rappesentante Azienda deve essere compreso tra i 2 e i 100 caratteri"
    //   ];
    // }
  }
  validazioneNomeRappresentante() {
    var valid: boolean = false;
    if (
      this.nomeRappresentanteAzienda === "" ||
      this.nomeRappresentanteAzienda === null
    ) {
      this.nomeRappresentanteRules = [true];
    } else {
      if (
        this.nomeRappresentanteAzienda !== "" ||
        this.nomeRappresentanteAzienda !== null
      ) {
        valid = /^[a-zA-Zìèéùòà'\x20]{2,100}$/.test(
          this.nomeRappresentanteAzienda
        );
      }
      if (valid) {
        this.nomeRappresentanteRules = [true];
      } else {
        this.nomeRappresentanteRules = [
          "Nome Rappesentante Azienda deve essere compreso tra i 2 e i 100 caratteri"
        ];
      }
    }
  }
  validazioneData() {
    var valid: boolean = false;
    if (
      this.dataNascitaRappresentante === "" ||
      this.dataNascitaRappresentante === null
    ) {
      this.dataRules = [true];
    } else {
      if (
        this.dataNascitaRappresentante !== "" ||
        this.dataNascitaRappresentante !== null
      ) {
        valid = /^[0-3]+[0-9]+\/[0-1]+[0-9]+\/[0-9]{4}$/.test(
          this.dataNascitaRappresentante
        );
      }
      if (valid) {
        this.dataRules = [true];
      } else {
        this.dataRules = ["La Data deve essere nel formato gg/mm/aaaa"];
      }
    }
  }
  validazioneLuogoNascita() {
    var valid: boolean = false;
    if (this.comuneAzienda === "" || this.comuneAzienda === null) {
      this.luogoRules = [true];
    } else {
      if (this.comuneAzienda !== "" || this.comuneAzienda !== null) {
        valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.comuneAzienda);
      }
      if (valid) {
        this.luogoRules = [true];
      } else {
        this.luogoRules = ["Comune non può avere più di 50 caratteri"];
      }
    }
  }
  validazioneTel() {
    var valid1: boolean = false;
    var valid2: boolean = false;
    var valid3: boolean = false;
    if (this.telefono1Azienda === "" || this.telefono1Azienda === null) {
      this.tel1Rules = [true];
    } else {
      valid1 = /[0-9]{8,15}$/.test(this.telefono1Azienda);
      if (valid1) {
        this.tel1Rules = [true];
      } else {
        this.tel1Rules = ["Il numero di telefono non ha un formato corretto"];
      }
    }
    if (this.telefono2Azienda === "" || this.telefono2Azienda === null) {
      this.tel2Rules = [true];
    } else {
      valid2 = /[0-9]{8,15}$/.test(this.telefono2Azienda);

      if (valid2) {
        this.tel2Rules = [true];
      } else {
        this.tel2Rules = ["Il numero di telefono non ha un formato corretto"];
      }
    }
    if (this.faxAzienda === "" || this.faxAzienda === null) {
      this.faxRules = [true];
    } else {
      valid3 = /[0-9]{8,15}$/.test(this.faxAzienda);
      if (valid3) {
        this.faxRules = [true];
      } else {
        this.faxRules = ["Il numero di fax non ha un formato corretto"];
      }
    }
  }
  validazioneEmail() {
    var valid: boolean = false;
    if (this.emailAzienda !== "" || this.emailAzienda !== null) {
      valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(
        this.emailAzienda
      );
    }
    if (valid) {
      this.emailRules = [true];
    } else if (this.emailAzienda === "" || this.emailAzienda === null) {
      this.emailRules = ["Email Utente necessaria"];
    } else {
      this.emailRules = ["Formato Email non corretto"];
    }
  }
  validazionePec() {
    var valid: boolean = false;
    if (this.pecAzienda === "" || this.pecAzienda === null) {
      this.pecRules = [true];
    } else {
      if (this.pecAzienda !== "" || this.pecAzienda !== null) {
        valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(
          this.pecAzienda
        );
      }
      if (valid) {
        this.pecRules = [true];
      } else {
        this.pecRules = ["Formato Pec non corretto"];
      }
    }
  }
  // validazionePIva() {
  //   if (this.pIva !== "") {
  //     this.pIvaRules = [true];
  //   } else {
  //     this.pIvaRules = ["Partita IVA necessaria"];
  //   }
  // }

  close() {
    this.denominazioneRules = [true];
    this.cognomeRappresentanteRules = [true];
    this.nomeRappresentanteRules = [true];
    this.luogoRules = [true];
    this.tel1Rules = [true];
    this.tel2Rules = [true];
    this.faxRules = [true];
    this.emailRules = [true];
    this.pecRules = [true];
    this.pIvaRules = [true];
    this.dataRules = [true];
    this.committenzaRules = [true];
    this.attivitàRules = [true];
    // this.pivaRules = [true];
    this.codRules = [true];
    this.numRules = [true];
    // this.idAtecoRules = [true];
    // this.descrAtecoRules = [true];
    // this.idIstatRules = [true];
    // this.descrIstatRules = [true];
    this.capRules = [true];
    this.indirizzoRules = [true];
    this.sitoRules = [true];
    bus.$emit("closeEditDialog");
    this.e1 = 1;
  }
  back() {
    this.e1 = 1;
    this.cognomeRappresentanteRules = [true];
    this.nomeRappresentanteRules = [true];
    this.luogoRules = [true];
    this.dataRules = [true];
  }
  backDue() {
    this.e1 = 2;
    this.tel1Rules = [true];
    this.tel2Rules = [true];
    this.faxRules = [true];
    this.emailRules = [true];
    this.pecRules = [true];
    this.sitoRules = [true];
    this.capRules = [true];
  }
  async executeTestInfo() {
    this.validazioneDenominazione();
    this.validazioneCommittenza();
    this.validazioneAttività();
    this.validazioneCod();
    this.validazioneNum();
    // this.validazioneIdAteco();
    // this.validazioneDescrAteco();
    // this.validazioneIdIstat();
    // this.validazioneDescrIstat();
    // this.validazionePIva();
  }
  async executeTestRappr() {
    this.validazioneCognomeRappresentante();
    this.validazioneNomeRappresentante();
    this.validazioneData();
    this.validazioneLuogoNascita();
  }
  async executeTestRecapiti() {
    if (this.estero === "true") {
      this.validazioneZip();
    } else {
      this.validazioneCap();
    }
    this.validazioneIndirizzo();
    this.validazioneTel();
    this.validazioneSito();
    this.validazioneEmail();
    this.validazionePec();
  }

  next() {
    this.executeTestInfo().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        this.e1 = 2;
      }
    });
  }

  nextDue() {
    this.executeTestRappr().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        this.e1 = 3;
      }
    });
  }

  save() {
    this.executeTestRecapiti().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        if (this.rapprEstero === "false") {
          this.statoNascitaRappresentante = "ITALIA";
        }
        if (this.estero === "false") {
          this.statoAzienda = "086";
          this.provinciaAzienda = "";
          this.comuneAzienda = "";
        }
        if (this.estero === "true") {
          this.provinciaAzienda = "ESTERA";
          this.idCapComuneAzienda = 0;
          if (this.statoAzienda === "086") {
            this.statoAzienda = "";
          }
        }
        var payload: EnterpriseInfo = {
          idAzienda: this.id,
          denominazioneAzienda: this.denominazioneAzienda,
          titolo: this.titolo,
          cognomeRappresentanteAzienda: this.cognomeRappresentanteAzienda,
          nomeRappresentanteAzienda: this.nomeRappresentanteAzienda,
          dataNascitaRappresentante: this.dataNascitaRappresentante,
          statoNascitaRappresentante: this.statoNascitaRappresentante,
          luogoNascitaRappresentante: this.luogoNascitaRappresentante,
          comuneAzienda: this.comuneAzienda,
          idCapComuneAzienda: this.idCapComuneAzienda,
          provinciaAzienda: this.provinciaAzienda,
          indirizzoAzienda: this.indirizzoAzienda,
          telefono1Azienda: this.telefono1Azienda,
          telefono2Azienda: this.telefono2Azienda,
          faxAzienda: this.faxAzienda,
          emailAzienda: this.emailAzienda,
          pecAzienda: this.pecAzienda,
          sitoAzienda: this.sitoAzienda,
          attivitàAzienda: this.attivitàAzienda,
          dipendentiAzienda: this.dipendentiAzienda,
          committenzaAzienda: this.committenzaAzienda,
          associata: this.associata,
          artigiana: this.artigiana,
          pIva: this.pIva,
          codAzienda: this.codAzienda,
          idAteco: this.idAteco,
          // idIstat: this.idIstat,
          // codAteco: this.codAteco,
          // codIstat: this.codIstat,
          descrizioneAteco: this.descrizioneAteco,
          descrizioneIstat: this.descrizioneIstat,
          cap: this.cap,
          idNazioneAzienda: this.statoAzienda,
          nazioneAzienda: this.nazioneAzienda,
          idStatoUtente: 2,
          codRappresentate: this.codRappresentate,
          confCommercio: this.confCommercio,
          altraAssociazione: this.altraAssociazione
        };
        user
          .dispatchEditEnterpriseInfo(this["$store"], payload)
          .then(() => {
            bus.$emit("editedEnterprise");
            bus.$emit(
              "successfullOperation",
              "Azienda aggiornata con successo"
            );
            this.close();
          })
          .catch(error => {
            if (error.response.status === 401) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit(
                "errorOperation",
                "Errore nella modifica delle informazioni"
              );
            }
          });
      }
    });
  }

  created() {
    if (
      this.info.idNazioneAzienda !== "086" &&
      this.info.idNazioneAzienda !== null
    ) {
      this.estero = "true";
    }
    if (this.statoNascitaRappresentante !== "ITALIA") {
      this.rapprEstero = "true";
    }
    data
      .dispatchComuniList(this["$store"])
      .then(result => {
        var obj = {
          id: 0,
          località: "",
          idProvincia: ""
        };
        result.forEach(element => {
          if (element.id !== 0) {
            obj = {
              id: element.id,
              località: element.località,
              idProvincia: element.idProvincia
            };
            this.comuni.push(obj);
          }
        });
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      });
    data
      .dispatchAtecoList(this["$store"])
      .then(result => {
        var ateco: string = "";
        var objAteco = {
          id: 0,
          descrizione: ""
        };
        result.forEach(element => {
          ateco = element.codice.trim() + " " + element.descrizione;
          objAteco = {
            id: element.id,
            descrizione: ateco
          };
          this.atecoList.push(objAteco);
        });
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista codici ATECO"
        );
      });
    // data
    //   .dispatchIstatList(this["$store"])
    //   .then(result => {
    //     var istat: string = "";
    //     var objIstat = {
    //       id: 0,
    //       descrizione: ""
    //     };
    //     result.forEach(element => {
    //       istat = element.codice.trim() + " " + element.descrizione;
    //       objIstat = {
    //         id: element.id,
    //         descrizione: istat
    //       };
    //       this.istatList.push(objIstat);
    //     });
    //   })
    //   .catch(error => {
    //     bus.$emit(
    //       "errorOperation",
    //       "Errore nel caricamento della lista codici ISTAT"
    //     );
    //   });
    data
      .dispatchStatiList(this["$store"])
      .then(result => {
        var obj = {
          idStato: "",
          nomeStato: ""
        };
        result.forEach(element => {
          if (element.idStato !== "086") {
            obj = {
              idStato: element.idStato,
              nomeStato: element.nomeStato
            };
            this.stati.push(obj);
          }
        });
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista nazioni"
        );
      });
  }
}
